import _objectSpread from "@babel/runtime/helpers/objectSpread2";
var _LightMenu;
import { MainMenuProvider } from "../MainMenu/context";
import LightMenu from "./LightMenu";
import { jsx as _jsx } from "react/jsx-runtime";
var LightMenuWithContext = function LightMenuWithContext(mainMenuProps) {
  return /*#__PURE__*/_jsx(MainMenuProvider, _objectSpread(_objectSpread({
    variant: "light"
  }, mainMenuProps), {}, {
    children: _LightMenu || (_LightMenu = /*#__PURE__*/_jsx(LightMenu, {}))
  }));
};
export default LightMenuWithContext;